/**
 * 請求額を表示用に整える。
 * 暫定か確定かは「暫定」「確定」のチップが伝えるため、金額の文字列には「約」を付けない。
 * @param amount - 金額（円）。null は「金額未定」
 * @returns 表示用の文字列
 */
export const formatAmount = (amount: number | null): string => {
  if (amount === null) return "金額未定";
  return `${amount.toLocaleString()}円`;
};

/**
 * ISO日時を「YYYY/MM/DD」にする。
 * @param value - ISO形式の日付または日時
 * @returns 表示用の日付
 */
export const formatDate = (value: string): string => {
  const date = new Date(value);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}/${month}/${day}`;
};

/**
 * 「YYYY-MM」を「YYYY年M月」にする。
 * @param month - 対象月（YYYY-MM）
 * @returns 表示用の年月
 */
export const formatMonth = (month: string): string => {
  const [year, m] = month.split("-");
  return `${year}年${Number(m)}月`;
};

/**
 * 「YYYY-MM-DD」（日付だけ）を「YYYY/MM/DD」にする。時差でずれないよう Date に通さない。
 * @param day - 日付（YYYY-MM-DD）
 * @returns 表示用の日付
 */
export const formatDay = (day: string): string => day.replaceAll("-", "/");
